export default __webpack_public_path__ + "static/media/kitchen3-afterB-1440w.e21c89bf.png";